<template>

	<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"
		background-color="#233242" text-color="#fff" active-text-color="#ffd04b">
		<el-menu-item>HSNMS 管理系统</el-menu-item>
		<el-menu-item index="0" @click="$router.push({path:'/admin/index'},onComplete => {},onAbort => {})">数据看板
		</el-menu-item>
		<el-menu-item class="el-icon-s-home" index="1"
			@click="$router.push({ path: '/admin/index' },onComplete => {},onAbort => {})"> 我的工作台
		</el-menu-item>
		<el-submenu index="2">
			<template slot="title">用户管理</template>
			<el-menu-item index="2-1"
				@click="$router.push({ path:'/admin/body/attribute'},onComplete => {},onAbort => {})">全部用户
			</el-menu-item>
			
			<el-menu-item index="2-2"
				@click="$router.push({ path:'/admin/body/attribute'},onComplete => {},onAbort => {})">注册用户
			</el-menu-item>
			
			<el-menu-item index="2-3"
				@click="$router.push({ path:'/admin/body/attribute'},onComplete => {},onAbort => {})">认证用户
			</el-menu-item>
			
			<el-menu-item index="2-4"
				@click="$router.push({ path:'/admin/body/attribute'},onComplete => {},onAbort => {})">异常用户
			</el-menu-item>
		</el-submenu>
		<el-menu-item index="3" disabled>消息中心</el-menu-item>
		<div style="text-align: right; line-height: 60px; margin-right: 20px; color: #FFFFFF;">
			Welcome To {{username}} , <el-button type="text"   @click="sign">Sign Out</el-button>
		</div>
	</el-menu>
</template>

<script>
	export default {
		data() {
			return {
				activeIndex: '1',
				username: this.$admin.getUser(),
			}
		},
		methods: {
			sign() {
				var msg = "您真的确定要退出系统吗？\n\n请确认！";
				if (confirm(msg) == true) {
					this.$admin.delUser()
					//alert("用户已退出！！");
					return true;
				} else {
					return false;
				}
			},
			handleSelect(key, keyPath) {
				//console.log(key, keyPath);
				console.log(key.length);
				console.log(key);
				this.activeIndex = key;
			}
		}
	}
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/views/admin/_layout/head.vue